module.exports = __webpack_public_path__ + "static/img/klab-illustration.c35eeb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/klab-illustration.svg
// module id = Cf3E
// module chunks = 0